import * as API from '../_api';

// import View from 'ol/View';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
// import {Tile as TileLayer} from 'ol/layer';
// import BingMaps from 'ol/source/BingMaps';
import {Cluster, Vector as VectorSource} from 'ol/source';
import {Circle as CircleStyle, RegularShape, Fill, Stroke, Style, Text} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import Supercluster from 'supercluster';
import {fromLonLat, toLonLat, transform, transformExtent} from 'ol/proj';

// @ts-ignore
export const read = async ({commit, dispatch}) => {
  try {
    const all = await API.read();
    commit('setLayers', all.data);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const init = async ({state, dispatch, commit, rootState}) => {
  // dispatch('map/addLayer', state.doctorsVectorLayer, {root: true});
  // dispatch('update', {map: rootState.map.map});
  if (state.doctorsVectorLayer) {
    dispatch('map/removeLayer', state.doctorsVectorLayer, {root: true});
  }

  commit('initColors');
  const ret = await API.read();
  state.doctors = ret.data.features;

  state.doctors.forEach((doctor: any) => {
    doctor.geometry.coordinates =
      transform(doctor.geometry.coordinates, 'EPSG:3857', 'EPSG:4326');
  });

  state.supercluster = new Supercluster({
    radius: 100,
    maxZoom: 20,
  });
  state.supercluster.load(state.doctors);

  const source = new VectorSource({});

  state.doctorsVectorLayer = new VectorLayer({
    source,
    style: (feature: any) => {
      const clusterId = feature.get('cluster_id');
      let props;
      if (clusterId) {
        const leave = state.supercluster.getLeaves(feature.get('cluster_id'), 1)[0];
        props = leave.properties;
      } else {
        props = feature.getProperties();
      }

      let fillColor = state.colors.fill.green;
      let strokeColor = state.colors.stroke.green;

      if (props.hauptfach === 'Allgemeinmedizin') {
        fillColor = state.colors.fill.red;
        strokeColor = state.colors.stroke.red;
      }

      if (props.hauptfach === state.hauptfach) {
        fillColor = state.colors.fill.blue;
        strokeColor = state.colors.stroke.blue;
      }

      let size = feature.get('point_count_abbreviated');
      if (!size) {
        size = '';
      }
      // TODO: check if color of styling is the same
      // let style = state.styleCacheDoctor[size];

      let image;
      if (props.kassenstat === 'alle Kassen' || props.kassenstat === 'GKK') {
        image = new CircleStyle({
          radius: 10,
          fill: fillColor,
          stroke: strokeColor,
        });
      } else {
        image = new RegularShape({
              fill: fillColor,
          stroke: strokeColor,
          points: 3,
          radius: 10,
          angle: 0,
        });
      }

      let style;
      if (!style) {
        const params = {
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: '#000000',
            }),
          }),
          image,
        };
        style = new Style(params);
        state.styleCacheDoctor[size] = style;
      }

      return style;
    },
  });


  dispatch('map/addLayer', state.doctorsVectorLayer, {root: true});
  dispatch('update', {map: rootState.map.map});
};

// @ts-ignore
export const setVisibility = ({state}, visibility) => {
  state.doctorsVectorLayer.setVisible(visibility);
};

// @ts-ignore
export const update = ({state}, data) => {
  const bbox = transformExtent(data.map.getView().calculateExtent(data.map.getSize()), 'EPSG:3857', 'EPSG:4326');
  const zoom = data.map.getView().getZoom();

  const features = [];
  const clusterArray = state.supercluster.getClusters(bbox, zoom);

  for (let i = 0; i < (clusterArray ? clusterArray.length : 0); ++i) {
    const feature = new Feature(new Point(
      fromLonLat(
        clusterArray[i].geometry.coordinates.map((numfloat: any) => {
          return parseFloat(numfloat);
        }),
      ),
    ));
    feature.setProperties(clusterArray[i].properties);
    features.push(feature);
  }
  const source = state.doctorsVectorLayer.getSource();
  // const source = data.map.getLayers().getArray()[1].getSource();
  source.clear();
  source.addFeatures(features);
};

// @ts-ignore
export const setHauptfach = ({state, rootState, dispatch}, hauptfach) => {
  state.hauptfach = hauptfach;

  dispatch('update', {map: rootState.map.map});
};
